/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { ChangeDetectionStrategy, Component, OnInit, Input, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import * as appStrings from '@touchplan/strings';
import { IListItemDef } from '../interfaces/IListItemDef';
import { EditorMode, IItemListEditorDelegate, ItemType } from './abstract-item-list-editor.component';
import { take } from 'rxjs/operators';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';

@Component({
	selector: 'app-item-list',
	templateUrl: './item-list.component.html',
	styleUrls: ['./item-list.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ItemListComponent<T> implements OnInit {
	@Input() public itemType: IListItemDef;
	@Input() public itemList: T[];
	@Input() public highlightItemInEdit: boolean;
	@Input() public enableItemDragAndDrop: boolean;
	@Input() public editor: IItemListEditorDelegate<T>;
	@Input() public customHeight: string = '550px';
	@Input() public hideItemList: boolean = false;

	@ViewChild(CdkVirtualScrollViewport) public virtualScroll: CdkVirtualScrollViewport;

	// use enum in template
	public readonly ITEM_TYPE = ItemType;
	public readonly EditorMode = EditorMode;

	public readonly LIST_ITEM_HEIGHT = 68; // pixels

	// for master list of colors if applicable
	public colorControl = new UntypedFormControl('');
	public isColorPickerShowing = false;

	public searchControl = new UntypedFormControl('');
	public strings = appStrings;

	public ngOnInit() {
		this.editor
			.getItemPaletteColors()
			.pipe(take(1))
			.subscribe((palette) => {
				let color = null;
				if (palette && palette[0]) {
					// initialize color for the picker to be the first
					color = palette[0][0];
				}
				this.colorControl = new UntypedFormControl(color);
			});
	}
}
